<!--
 * @Description:分配客户负责人组件
 * @Author: mdb
 * @Date: 2022-07-13 16:10:45
 * @LastEditTime: 2023-03-10 15:34:02
 * @LastEditors: cxh
-->
<template>
  <a-modal
    v-model:visible="visible"
    :title="t('clue.asignOwner')"
    :body-style="{ padding: '30px' }"
    :confirm-loading="loading"
    @ok="handleOk"
    :okText="t('btn.confirm')"
    @cancel="handleCancel"
  >
    <a-form :wrapper-col="{ span: 24 }">
      <a-form-item :label="t('clue.followerName')" v-bind="validateInfos.follower">
        <UserSelect v-model:value="dataForm.follower" :status="1" allowClear />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue'
import { Form } from 'ant-design-vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { salesClueAllot } from '@/api/overseasSales/clueManage'
import type { SalesClueListItem } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const useForm = Form.useForm
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const dataForm = reactive<{ follower: string; clueIdList: any[] }>({ follower: '', clueIdList: [] })
const formRules = reactive({
  follower: [{ required: true, message: t('clue.selectSellor') }]
})
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)

const init = (data: SalesClueListItem[]) => {
  selectedData.value = data
  visible.value = true
}

const emit = defineEmits(['fetch'])
const handleOk = () => {
  validate().then(() => {
    loading.value = true
    dataForm.clueIdList = selectedData.value.map((item: SalesClueListItem) => item.clueId)
    const params = Object.assign({}, dataForm)
    salesClueAllot(params)
      .then(() => {
        emit('fetch', dataForm.follower)
        DcMessage.success(t('tips.assignedSuccees'))
        resetFields()
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  resetFields()
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'ClueAssign' }
</script>

<style scoped></style>
